import http from './http.js'
const project = 'imr-user/'
const model = 'user'

const user = {

  // 查询用户列表
  getList (data, page) {
    const url = project + model + '/list/' + page + '/10'
    return http.post(url, data).then(res => {
      return res
    })
  },

  // 获取用户数据
  getUserInfo () {
    const url = project + model + '/user_info'
    return http.get(url).then(res => {
      return res
    })
  },
}

export default user